export default "__VITE_ASSET__79567491__"